<template>
    <div style="background-color: white;">
        <!--<img src="http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2NTYNESz.png" width="100%" />-->
        <!--<div style="text-align:center;margin:2rem 0;">-->
            <!--<img src="http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2NTXyF6U.png" width="50%" />-->
        <!--</div>-->
        <!--<div style="width:90%;margin:0 auto;">-->
            <!--微信扫码-填手机号-自动下载app-使用填写的手机号登陆-弹窗-立即领取-实名-出额度-完成拉新-返回优推页面上报手机号-->
        <!--</div>-->
        <!--<div style="text-align:center; margin: 3rem 0;">-->
            <!--<van-field v-model="query.phone" type="number" label="手机号" placeholder="请输入开通额度手机号" class="input" />-->
            <!--<van-button type="primary" size="normal" @click="simpleJobOrderDeclare" class="declareButton">点击报单</van-button>-->
        <!--</div>-->
        <!--<div style="width:90%;margin:0 auto;">-->
            <!--注意事项：<br/>-->
            <!--1.此界面输入手机号必须和爱上街拉新手机号一致，否则会影响拉新数据<br/>-->
            <!--2.新用户在活动页面验证手机号,在爱上街完成实名出额度，推荐用户0.01元购-->
        <!--</div>-->
        <div>爱上街风控升级，两天后开放做单</div>
    </div>
</template>

<script>
    import mainAPI from '@/api/main';
    import pvuvAPI from '@/api/pvuv';

    export default {
        data() {
            return {
                query: {
                    jobId: this.$route.query.jobId,
                    traderId: this.$route.query.traderId,
                    jobLinkUpPid: this.$route.query.pid,
                    phone: '',
                },
            }
        },
        methods: {
            simpleJobOrderDeclare() {
                if (!this.$myUtil.mobile(this.query.phone)) {
                    this.$toast("请输入正确的手机号");
                    return;
                }
                mainAPI.simpleJobOrderDeclare(this.query).then(() => {
                    this.$toast("上报成功");
                    this.query.phone = '';
                }).catch(() => {
                });
            },
        },
        created() {
        },
        mounted() {
            pvuvAPI.addPv("jobDeclare/asjDeclare", this.query.traderId).then((result) => {
            });
        }
    }

</script>

<style lang="scss" scoped>

    .input {
        height: 5rem;
        font-size: 1.5rem;
        margin: 1rem 0;
    }

    .declareButton {
        width: 15rem;
        font-size: 1.5rem;
        font-weight: bold;
        color: #FFFFFF;
    }

</style>
